// src/components/AlbumPageTemplates/StepIntro.jsx
// FIXED VERSION - Map at TOP, no stats strip text, position stable

import React from 'react';
import styled from 'styled-components';
import PrintSafeImage from '../PrintSafeImage';
import { sanitizeRichText } from '../../utils/pastTripsAlbumTemplate';

// Main container for the two-panel layout
const PageContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  font-family: 'Lato', sans-serif;
  background-color: #ffffff;
`;

// Left side: Metadata Panel with fixed layout
const InfoPanel = styled.div`
  flex: 0 0 40%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  background-color: #f9f7f5;
`;

// Right side: Photo Panel
const PhotoPanel = styled.div`
  flex: 1 1 60%;
  background: #e0e0e0;
  overflow: hidden;
  position: relative;
`;

const Title = styled.h2`
  font-family: 'Playfair Display', serif;
  font-size: 2.8em;
  font-weight: 700;
  line-height: 1.1;
  margin: 0 0 10px 0;
  color: #1a1a1a;
`;

const Subtitle = styled.p`
  margin: 0 0 20px 0;
  color: #555;
  font-size: 1.1em;
`;

// Map at the TOP - fixed size
const MicroMap = styled.div`
  border: 1px solid #e0e0e0;
  height: 180px;
  background: #eaeaea;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 30px;
  flex: 0 0 auto; /* Fixed size, won't shrink */
`;

// Journal text fills remaining space
const JournalText = styled.div`
  color: #444;
  font-family: 'Georgia', serif;
  font-style: italic;
  font-size: 1.0em;
  line-height: 1.6;
  flex: 1 1 auto;
  overflow-y: auto;
`;

export default function StepIntro({ items = [], meta, isPrinting }) {
  const photo = items[0];
  
  const title = meta?.title || 'Location Name';
  const date = meta?.date || 'Date of Travel';
  const place = meta?.place || 'Region';
  const journalText = meta?.journalText || '';
  const stepMapUrl = meta?.stepMapUrl;

  // Apply Step Intro Style from meta
const introStyle = meta?.stepIntroStyle || {};
const titleSizeMap = { medium: '2.2em', large: '2.8em', xlarge: '3.2em' };
const titleFontSize = titleSizeMap[introStyle.titleSize] || titleSizeMap.large;
const titleColor = introStyle.titleColor || '#1a1a1a';
const dateColor = introStyle.dateColor || '#555';

  
  const position = photo?.position || { x: 50, y: 50, scale: 100 };
  
  // Style for the main photo
  const photoStyle = isPrinting ? {
    // PDF-safe styles
    position: 'absolute',
    width: '100%',
    height: 'auto',
    minWidth: '100%',
    minHeight: '100%',
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%) scale(${position.scale / 100}) translateX(${position.x - 50}%) translateY(${position.y - 50}%)`,
  } : {
    // LIVE PREVIEW styles
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: `${position.x}% ${position.y}%`,
    transform: `scale(${position.scale / 100})`,
    transformOrigin: `${position.x}% ${position.y}%`,
  };
  
  // Style for the map image
  const mapStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '8px',
  };

  return (
    <PageContainer>
      <InfoPanel>
        <Title style={{ color: titleColor, fontSize: titleFontSize }}>{title}</Title>
<Subtitle style={{ color: dateColor }}>{date}</Subtitle>

        
        {/* MAP AT THE TOP */}
        <MicroMap>
          {stepMapUrl ? (
            <PrintSafeImage
              src={stepMapUrl}
              alt={`Map of ${title}`}
              style={mapStyle}
              isPrinting={isPrinting}
            />
          ) : (
            <div style={{ 
              width: '100%', 
              height: '100%', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              color: '#999',
              fontSize: '0.9em'
            }}>
              Micro-Map Placeholder
            </div>
          )}
        </MicroMap>
        
        {/* JOURNAL TEXT - fills remaining space */}
        {/* JOURNAL TEXT - sanitized HTML */}
        {journalText && (
          <JournalText
            dangerouslySetInnerHTML={{
              __html: sanitizeRichText(journalText)
            }}
          />
        )}
      </InfoPanel>

      <PhotoPanel>
        {photo?.url && (
          <PrintSafeImage
            src={photo.url}
            alt={title}
            style={photoStyle}
            position={position}
            isPrinting={isPrinting}
          />
        )}
      </PhotoPanel>
    </PageContainer>
  );
}